import React from 'react';

import Link from 'next/link';

// ── SVG Icon Library ─────────────────────────────────────────────────────────
const SocialIcons = {
  Facebook: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.87112 7.81553L10.2568 5.30097H7.84418V3.66917C7.84418 2.98124 8.18118 2.31068 9.26181 2.31068H10.3587V0.169904C10.3587 0.169904 9.36323 0 8.41148 0C6.42443 0 5.12573 1.20427 5.12573 3.38447V5.30097H2.91699V7.81553H5.12573V13.8943C5.56862 13.9638 6.02255 14 6.48495 14C6.94736 14 7.40129 13.9638 7.84418 13.8943V7.81553H9.87112Z"
        fill="white"
      />
    </svg>
  ),
  Instagram: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_instagram)">
        <path
          d="M7.71974 0.000922283C8.23054 -0.00103781 8.74134 0.0040959 9.25199 0.0163218L9.38778 0.0212216C9.54458 0.0268214 9.69927 0.0338212 9.88617 0.0422209C10.6309 0.0772197 11.1391 0.194816 11.585 0.36771C12.047 0.545504 12.4362 0.786295 12.8254 1.17548C13.1812 1.52519 13.4566 1.94822 13.6324 2.41514C13.8053 2.86102 13.9229 3.36991 13.9579 4.11468C13.9663 4.30088 13.9733 4.45627 13.9789 4.61307L13.9831 4.74886C13.9956 5.25928 14.0009 5.76984 13.9992 6.28041L13.9999 6.80259V7.71956C14.0017 8.23036 13.9963 8.74116 13.9838 9.25181L13.9796 9.3876C13.974 9.5444 13.967 9.69909 13.9586 9.88599C13.9236 10.6308 13.8046 11.1389 13.6324 11.5848C13.4572 12.0522 13.1817 12.4756 12.8254 12.8252C12.4754 13.181 12.0521 13.4564 11.585 13.6323C11.1391 13.8052 10.6309 13.9227 9.88617 13.9577C9.69927 13.9661 9.54458 13.9731 9.38778 13.9787L9.25199 13.9829C8.74134 13.9954 8.23054 14.0008 7.71974 13.999L7.19756 13.9997H6.28129C5.77049 14.0015 5.25969 13.9961 4.74904 13.9836L4.61325 13.9794C4.44708 13.9734 4.28095 13.9664 4.11486 13.9584C3.37009 13.9234 2.86191 13.8045 2.41532 13.6323C1.94822 13.4568 1.52512 13.1813 1.17566 12.8252C0.819408 12.4754 0.543742 12.0521 0.367891 11.5848C0.194997 11.1389 0.0774012 10.6308 0.0424024 9.88599C0.0346067 9.71989 0.0276069 9.55376 0.0214032 9.3876L0.0179034 9.25181C0.00499831 8.74116 -0.000835454 8.23036 0.000403887 7.71956V6.28041C-0.00154972 5.76985 0.00358398 5.25928 0.0158034 4.74886L0.0207032 4.61307C0.026303 4.45627 0.0333028 4.30088 0.0417025 4.11468C0.0767013 3.36921 0.194297 2.86172 0.367191 2.41514C0.543146 1.94799 0.819351 1.52508 1.17636 1.17618C1.52558 0.819721 1.94841 0.543805 2.41532 0.36771C2.86191 0.194816 3.36939 0.0772197 4.11486 0.0422209L4.61325 0.0212216L4.74904 0.0177218C5.25945 0.00482324 5.77002 -0.00101052 6.28059 0.000222357L7.71974 0.000922283ZM7.00017 3.5008C6.53644 3.49424 6.07603 3.57992 5.6457 3.75284C5.21536 3.92577 4.82369 4.1825 4.49344 4.50811C4.16319 4.83372 3.90095 5.22172 3.72196 5.64956C3.54297 6.07741 3.45079 6.53656 3.45079 7.00033C3.45079 7.46411 3.54297 7.92326 3.72196 8.3511C3.90095 8.77895 4.16319 9.16695 4.49344 9.49256C4.82369 9.81817 5.21536 10.0749 5.6457 10.2478C6.07603 10.4208 6.53644 10.5064 7.00017 10.4999C7.92839 10.4999 8.8186 10.1311 9.47496 9.47477C10.1313 8.81842 10.5 7.92821 10.5 6.99998C10.5 6.07176 10.1313 5.18155 9.47496 4.52519C8.8186 3.86884 7.92839 3.5008 7.00017 3.5008ZM7.00017 4.90076C7.27911 4.89562 7.55628 4.94611 7.8155 5.0493C8.07471 5.15248 8.31076 5.30628 8.50986 5.50172C8.70896 5.69715 8.86713 5.9303 8.97511 6.18755C9.08309 6.4448 9.13873 6.72098 9.13878 6.99998C9.13883 7.27897 9.08328 7.55518 8.97538 7.81246C8.86748 8.06974 8.7094 8.30295 8.51036 8.49845C8.31132 8.69395 8.07532 8.84783 7.81615 8.9511C7.55697 9.05437 7.27981 9.10496 7.00087 9.09991C6.44393 9.09991 5.90981 8.87867 5.51599 8.48486C5.12218 8.09105 4.90094 7.55692 4.90094 6.99998C4.90094 6.44305 5.12218 5.90892 5.51599 5.51511C5.90981 5.1213 6.44393 4.90006 7.00087 4.90006L7.00017 4.90076ZM10.675 2.45084C10.4492 2.45988 10.2357 2.55594 10.0791 2.71891C9.92251 2.88188 9.83506 3.09911 9.83506 3.32511C9.83506 3.55111 9.92251 3.76834 10.0791 3.93131C10.2357 4.09428 10.4492 4.19034 10.675 4.19938C10.9071 4.19938 11.1297 4.10719 11.2937 3.94311C11.4578 3.77902 11.55 3.55647 11.55 3.32441C11.55 3.09235 11.4578 2.8698 11.2937 2.70571C11.1297 2.54162 10.9071 2.44944 10.675 2.44944V2.45084Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_instagram">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  LinkedIn: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.04818 2.91667C4.04802 3.22609 3.92496 3.52277 3.70606 3.74146C3.48715 3.96014 3.19035 4.08291 2.88093 4.08275C2.57151 4.0826 2.27482 3.95953 2.05614 3.74063C1.83746 3.52173 1.71469 3.22492 1.71484 2.9155C1.715 2.60608 1.83806 2.3094 2.05697 2.09072C2.27587 1.87203 2.57267 1.74927 2.88209 1.74942C3.19151 1.74958 3.4882 1.87264 3.70688 2.09154C3.92556 2.31044 4.04833 2.60725 4.04818 2.91667ZM4.08318 4.94667H1.74984V12.25H4.08318V4.94667ZM7.76984 4.94667H5.44818V12.25H7.74651V8.4175C7.74651 6.2825 10.529 6.08417 10.529 8.4175V12.25H12.8332V7.62417C12.8332 4.025 8.71484 4.15917 7.74651 5.92667L7.76984 4.94667Z"
        fill="white"
      />
    </svg>
  ),
  YouTube: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7074 3.63494C13.5464 3.03073 13.0721 2.55494 12.4697 2.39346C11.3779 2.09999 7 2.09999 7 2.09999C7 2.09999 2.62208 2.09999 1.53029 2.39346C0.927945 2.55494 0.453533 3.03073 0.292547 3.63494C0 4.73004 0 7.01489 0 7.01489C0 7.01489 0 9.2997 0.292547 10.3949C0.453533 10.999 0.927945 11.4748 1.53029 11.6364C2.62208 11.9298 7 11.9298 7 11.9298C7 11.9298 11.3779 11.9298 12.4697 11.6364C13.0721 11.4748 13.5464 10.999 13.7074 10.3949C14 9.2997 14 7.01489 14 7.01489C14 7.01489 14 4.73004 13.7074 3.63494Z"
        fill="white"
      />
      <path
        d="M5.56836 9.08936L9.22745 7.01499L5.56836 4.94043V9.08936Z"
        fill="#514FA8"
      />
    </svg>
  ),
  TikTok: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z" />
    </svg>
  ),
};

// ── Component Definition ─────────────────────────────────────────────────────
export const FooterSocials: React.FC<{
  socialLinks: { platform: string; href: string; label: string }[];
}> = ({ socialLinks }) => {
  if (!socialLinks || socialLinks.length === 0) {
    return null; // Don't render the component if there are no social links
  }

  return (
    <div className="flex min-w-0 flex-col">
      <h3 className="font-mulish mb-6 text-xl font-bold text-white">
        Follow us on
      </h3>
      <div className="grid w-fit grid-cols-3 gap-4">
        {socialLinks.map((social) => {
          const IconComponent =
            SocialIcons[social.platform as keyof typeof SocialIcons];

          return (
            <Link
              key={social.platform}
              href={social.href}
              aria-label={social.label}
              rel="noreferrer"
              target="_blank"
              className="group"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-white transition-colors duration-200 group-hover:bg-white/30">
                {IconComponent ? <IconComponent /> : null}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FooterSocials;
